import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { debounceTime, filter, Observable } from 'rxjs';
import { hasValue } from 'src/app/angular-core/utils/functions/common.functions';
import { Address, LocationHandle } from 'src/app/generated/CrossPoint.RemoteXpac.Server';
import { getLocationAutocompleteAction, getLocationAutocompleteSuccessAction, getLocationDataByAddressAction, getLocationDataByAddressSuccessAction } from 'src/app/store/actions/devices.actions';
import { selectCurrentAutocompleteAddress, selectLocationAutocompleteData } from 'src/app/store/selectors/devices.selectors';
import { IRemoteXPACPortalState } from 'src/app/utils/interfaces/store.interfaces';


@UntilDestroy()
@Component({
  selector: 'app-address-search',
  templateUrl: './address-search.component.html',
  styleUrls: ['./address-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressSearchComponent implements OnInit {

  @Output()
  public address = new EventEmitter<Address>();
  
  public get disabled() : boolean {
    return this.searchAddressControl.disabled;
  }

  @Input()
  public set disabled(v : boolean) {
    if (v) {
      this.searchAddressControl.disable();
    }
    else {
      this.searchAddressControl.enable();
    }
  }

  public searchText: string = "";
  public isFocused: boolean = false;
  

  public searchAddressControl: FormControl<string> = new FormControl<string>('');
  public selectLocationAutocompleteData$: Observable<LocationHandle[]> = this.store.select(selectLocationAutocompleteData);

  constructor(
    private readonly store: Store<IRemoteXPACPortalState>,
  ) {
  }
  
  public ngOnInit(): void {
    // Ensure the store is reset
    this.store.dispatch(getLocationDataByAddressSuccessAction({ data: null }));
    this.store.dispatch(getLocationAutocompleteSuccessAction({ data: null }));
    
    this.searchAddressControl.valueChanges
      .pipe(
        filter(hasValue),
        untilDestroyed(this),
        debounceTime(500)
      )
      .subscribe((data: string) => {
        this.searchText = data;
        if(data != null && data.length > 0) {
          this.store.dispatch(getLocationAutocompleteAction({ data }))
        }
        else {
          this.store.dispatch(getLocationDataByAddressSuccessAction({ data: null }));
          this.store.dispatch(getLocationAutocompleteSuccessAction({ data: null }));
        }
      });
    
    this.store.select(selectCurrentAutocompleteAddress)
      .pipe(
        filter(hasValue),
        untilDestroyed(this),
      )
      .subscribe((address) => {
        const emptyAddress: Address = {
          country: '',
          state: '',
          city: '',
          street: '',
          streetNumber: '',
          zipCode: '',
        };

        const finalAddress: Address = {
          ...emptyAddress,
          ...address,
        };

        this.address.emit(finalAddress);
      });
  }

  public getLocationDataByAddress(token: string): void {
    this.store.dispatch(getLocationDataByAddressAction({ data: token }))
  }

  public async onFocus(): Promise<void> {
    if (this.isFocused) {
      await new Promise(f => setTimeout(f, 100));
    }
    this.isFocused = !this.isFocused;
  }


  public emptyValue(): void{
    this.searchAddressControl.setValue("");
    this.searchText="";
  }
}
